import { SvgIcon, SvgIconProps } from '@mui/material';

const TextareaDragHandle = ({ htmlColor, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox='0 0 16.83 16.83' {...props} data-testid='TextareaDragHandleIcon'>
      <line
        x1='1.41'
        y1='15.41'
        x2='15.41'
        y2='1.41'
        fill='none'
        stroke={htmlColor || '#000'}
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
      />
      <line
        x1='9.41'
        y1='15.41'
        x2='15.41'
        y2='9.41'
        fill='none'
        stroke={htmlColor || '#000'}
        strokeLinecap='square'
        strokeMiterlimit='10'
        strokeWidth='2'
      />
    </SvgIcon>
  );
};

export default TextareaDragHandle;
